import { useLocale } from "@i18n/react";
import { useCallback } from "react";

export const useGetNumberFormattedFn = () => {
  const locale = useLocale();

  const getNumberFormattedFn = useCallback(
    ({ currency }: { currency: string }) => {
      return new Intl.NumberFormat(locale, {
        currency: currency ?? "usd",
        style: "currency",
      });
    },
    [locale],
  );

  return { getNumberFormattedFn };
};
